import React from 'react'
import styled from 'app-view/styles/styled'
import { ClipboardIcon } from 'app-view/components/icons'

const InputError = styled.div`
  padding-top: 10px;
  line-height: 1;
  font-size: 0.75rem;
  font-weight: 500;
  color: #f34040;
  text-align: center;
`

const InputMessage = styled.div`
  padding-top: 10px;
  line-height: 1;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
`

const InputContainer = styled.div`
  position: relative;
`

const StyledClipboardIcon = styled(ClipboardIcon)`
  position: absolute;
  bottom: 16px;
  right: 19px;
  height: 24px;
  width: 24px;
  cursor: pointer;
  background-color: #fff;
  padding-left: 4px;
`

export const StyledInput = styled.textarea`
  border: 1px solid #ccc;
  border-radius: 10px;
  font-family: Mulish, sans-serif;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  resize: none;
  line-height: 1.66;
  word-break: break-word;
  font-weight: 400;
  text-align: center;
  padding: 14px 25px 14px 1.5rem;
  outline: 1px 1px;
  outline-color: #cccccc;
  user-select: auto;
  color: #a4a4a4;

  &::placeholder {
    font-weight: 400;
    text-align: center;
    pointer-events: all;
    font-size: 1rem;
  }

  &:focus-visible {
    outline-color: #cccccc;
  }
`

// Extend html <input> props
interface InputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  error?: string
  message?: string
  icon?: string
  onCopy?: () => void
}

export const SlateInput: React.FC<InputProps> = ({ error, message, onCopy, ...props }) => {
  return (
    <>
      <InputContainer>
        {onCopy && <StyledClipboardIcon onClick={onCopy} />}
        {/* @ts-ignore TODO: fix types */}
        <StyledInput
          type="text"
          // onClick={onCopy ? onCopy : props.onClick}
          name="copy-text-input"
          {...props}
          style={{ borderColor: error ? '#f34040 !important' : '#ccc' }}
        />
      </InputContainer>
      {error && <InputError>{error}</InputError>}
      {message && <InputMessage>{message}</InputMessage>}
    </>
  )
}
